import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import "./../styles/car-rental.css";
import emailjs from "emailjs-com";
import AchievementsSection from "../shared/AchievementsSection";

import { Helmet } from "react-helmet";

import car1 from "./../assets/images/car1.png";
// import car2 from "./../assets/images/car2.jpg";
import car3 from "./../assets/images/car3.jpg";
import car4 from "./../assets/images/car10.jpg";
// import car5 from "./../assets/images/car5.jpg";
// import car6 from "./../assets/images/car6.jpg";
import car7 from "./../assets/images/car7.jpg";
import car8 from "./../assets/images/car8.jpg";
import car9 from "./../assets/images/car9.jpg";
import Newsletter from "../shared/Newsletter";
import Subtitle from "../shared/Subtitle";

const CarRental = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isFormOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    fromDate: "",
    mobileNumber: "",
    destination: "",
    pickFrom: "",
    numberOfPeople: 0,
  });
  const [selectedCar, setSelectedCar] = useState(null);

  // Your emailjs service parameters (replace with your actual service details)
  const serviceID = "service_m6apr1s";
  const templateID = "template_1js3ywy";
  const userID = "5jHtz5YTo4yK5yAXW";

  const carData = [
    {
      name: "Toyota Innova",
      category: "Premium Services",
      capacity: "Seating Capacity: 5 + Driver",
      luggage: "Luggage: 2 Large Suitcases + 3 Small Bags",
      image: car1,
    },
    {
      name: "Maruti Suzuki",
      category: "Premium Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: car7,
    },
    {
      name: "XL-6",
      category: "Premium Services",
      capacity: "Seating Capacity: 9 + Driver",
      luggage: "Luggage: 5 Large Suitcases + 3 Small Bags",
      image: car4,
    },
    {
      name: "Etios",
      category: "Economy Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: car3,
    },
    {
      name: "Ertiga",
      category: "Deluxe Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: car8,
    },
    
    // {
    //   name: "Tata Indigo",
    //   category: "Budget Services",
    //   capacity: "Seating Capacity: 3 + Driver",
    //   luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
    //   image: car2,
    // },
    {
      name: "Dzire",
      category: "Economy Services",
      capacity: "Seating Capacity: 3 + Driver",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: car9,
    },
    
    // {
    //   name: "Mini Coach",
    //   category: "Small Luxury Passenger Services",
    //   capacity: "Seating Capacity: 18 + Driver",
    //   luggage: "Luggage: 13 Standard-sized Suitcases",
    //   image: car5,
    // },
    
  ];

  const filteredCars = carData.filter(
    (car) => car.category === selectedCategory || selectedCategory === ""
  );

  const openForm = (car) => {
    setFormOpen(true);
    setSelectedCar(car);
  };

  const closeForm = () => {
    setFormOpen(false);
    setFormData({
      name: "",
      fromDate: "",
      destination: "",
      pickFrom: "Delhi",
      numberOfPeople: 0,
    });
    setSelectedCar(null); // Reset selected car when closing the form
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "fromDate") {
      const today = new Date().toISOString().split("T")[0];
      if (value < today) {
        return;
      }
    }

    if (name === "numberOfPeople") {
      if (value < 0) {
        return;
      }
    }

    setFormData({ ...formData, [name]: value });
  };

  const templateParams = {
    name: formData.name,
    mobileNumber: formData.mobileNumber,
    email: formData.email,
    fromDate: formData.fromDate,
    destination: formData.destination,
    pickFrom: formData.pickFrom,
    numberOfPeople: formData.numberOfPeople,
    selectedCar: selectedCar ? selectedCar.name : "N/A",
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(serviceID, templateID, templateParams, userID)
      .then((response) => {
        console.log("Email sent successfully:", response);
        closeForm();
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
      });
  };

  return (
    <>
      <Helmet>
        <title>
          Car Rental Services in India | Book Your Car Today! | Private Driver
          In India
        </title>
        <meta
          name="description"
          content="Need to rent a car in India? Look no further! We offer a wide range of car rental services to suit your needs, including short-term and long-term rentals, airport transfers, and chauffeur services. We also have a variety of cars to choose from, including sedans, SUVs, and vans. Book your car today and experience the best car rental services in India!"
        />
      </Helmet>
      <section className="car-rental-section py-12">
        <Container>
          <Row>
            <div className="container mx-auto px-4">
              <h2 className="text-3xl font-semibold text-gray-800 mt-4 mb-8">
                Car Rental Service & Custom Tour Packages
              </h2>

              <div className="button__group mb-4" style={{ marginTop: "20px" }}>
                <button
                  onClick={() => setSelectedCategory("")}
                  className={`filter-button ${
                    selectedCategory === "" ? "active" : ""
                  }`}
                >
                  All Services
                </button>
                
                <button
                  onClick={() => setSelectedCategory("Premium Services")}
                  className={`filter-button ${
                    selectedCategory === "Premium Services" ? "active" : ""
                  }`}
                >
                  Premium Services
                </button>
                <button
                  onClick={() => setSelectedCategory("Deluxe Services")}
                  className={`filter-button ${
                    selectedCategory === "Deluxe Services" ? "active" : ""
                  }`}
                >
                  Deluxe Services
                </button>
                <button
                  onClick={() => setSelectedCategory("Economy Services")}
                  className={`filter-button ${
                    selectedCategory === "Economy Services" ? "active" : ""
                  }`}
                >
                  Economy Services
                </button>
                {/* <button
                  onClick={() => setSelectedCategory("Budget Services")}
                  className={`filter-button ${
                    selectedCategory === "Budget Services" ? "active" : ""
                  }`}
                >
                  Budget Services
                </button>
                <button
                  onClick={() =>
                    setSelectedCategory("Small Luxury Passenger Services")
                  }
                  className={`filter-button ${
                    selectedCategory === "Small Luxury Passenger Services"
                      ? "active"
                      : ""
                  }`}
                >
                  Small Luxury Passenger Services
                </button> */}
              </div>

              <Row>
                {filteredCars.map((car, index) => (
                  <Col key={index} sm="12" md="6" lg="4" className="mb-4">
                    <div className="car__option bg-white p-6 rounded-lg shadow-lg flex relative">
                      <div className="w-1/2">
                        <img src={car.image} alt={car.name} className="w-full h-auto" />
                      </div>
                      <div className="text w-1/2">
                        <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center border-b pb-2">
                          {car.name}
                        </h3>
                        <div className="text-center text-gray-600 mb-4">
                          <strong>Category:</strong> {car.category}
                        </div>
                        <div className="text-center text-gray-600 mb-4">
                          <strong>Seating Capacity:</strong> {car.capacity}
                        </div>
                        <div className="text-center mb-4">
                          <strong>Luggage Capacity:</strong> {car.luggage}
                        </div>
                        <div className="text-center ">
                          <button
                            onClick={() => openForm(car)}
                            className="btn primary__btn bg-blue-500 text-white px-4 py-3 rounded-full hover.bg-blue-600 mb-4"
                          >
                            Book This Car
                          </button>
                        </div>
                      </div>
                      <div className="blur-border"></div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <Col lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>

        {isFormOpen && (
          <div className="form-popup">
            <form onSubmit={handleSubmit}>
              <label>
                Name:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Mobile Number:
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleInputChange}
                  pattern="[0-9]{10}"
                  title="Please enter a valid 10-digit phone number"
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                From Date:
                <input
                  type="date"
                  name="fromDate"
                  value={formData.fromDate}
                  onChange={handleInputChange}
                  min={new Date().toISOString().split("T")[0]}
                />
              </label>
              <label>
                Destination:
                <input
                  type="text"
                  name="destination"
                  value={formData.destination}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Pick From:
                <input
                  type="text"
                  name="pickFrom"
                  value={formData.pickFrom}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Number of People:
                <input
                  type="number"
                  name="numberOfPeople"
                  value={formData.numberOfPeople}
                  onChange={handleInputChange}
                  min="0"
                />
              </label>
              <button type="submit">Submit</button>
              <button type="close" onClick={closeForm}>
                Close
              </button>
            </form>
          </div>
        )}
      </section>

      <section>
        <Container>
          <Row>
            <Col lg="12">
              <div style={{ backgroundColor: "#ffffff" }}>
                {/* <h2 align="center" className="services__subtitle">
                  Few of our achievements
                </h2> */}
                <Subtitle subtitle={"Few of our achievements"}/>
              </div>
            </Col>
            <Col lg="12">
              <AchievementsSection />
            </Col>
          </Row>
        </Container>
      </section>

      {/* ... (your existing Newsletter component) */}
      <Newsletter />
    </>
  );
};

export default CarRental;
